import { cn } from "../lib/utils";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

interface ServiceCardProps {
  title: string;
  description: string;
  imageSrc: string;
  /** 768px-brede variant voor telefoons; samen met imageSrc als srcset. */
  imageSrc768?: string;
  imageAlt: string;
  /** Slug van de dienst — maakt van de kaart een link naar de subdienstpagina. */
  slug?: string;
  /**
   * Zet dit op de eerste kaart boven de vouw: de afbeelding laadt dan direct
   * met hoge prioriteit in plaats van lazy, wat de LCP op mobiel versnelt.
   */
  priority?: boolean;
  className?: string;
}


export function ServiceCard({
  title,
  description,
  imageSrc,
  imageSrc768,
  imageAlt,
  slug,
  priority = false,
  className,
}: ServiceCardProps) {

  const content = (
    <>
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={imageSrc}
          srcSet={imageSrc768 ? `${imageSrc768} 768w, ${imageSrc} 1200w` : undefined}
          sizes={
            imageSrc768
              ? "(min-width: 1024px) 400px, (min-width: 640px) 50vw, calc(100vw - 2rem)"
              : undefined
          }
          alt={imageAlt}
          width={1200}
          height={900}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"

          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <h3 className="font-heading text-lg font-semibold text-foreground">{title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{description}</p>
        {slug && (
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary transition-colors group-hover:text-primary/80">
            Lees verder
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              aria-hidden="true"
            />
          </span>
        )}
      </div>
    </>
  );

  const cardClasses = cn(
    "group overflow-hidden rounded-xl border border-border/60 bg-card transition-all hover:border-primary/30 hover:bg-card/80",
    className,
  );

  if (slug) {
    return (
      <Link to="/diensten/$slug" params={{ slug }} className={cardClasses}>
        {content}
      </Link>
    );
  }

  return <div className={cardClasses}>{content}</div>;
}

